/**
 * The sidebar's **Content** section menu (`specs/M1-B10-shell-chrome.md` §4.2).
 *
 * Measured `[c:sidebar-content-menu]`: **240 × 64**, exactly two 32 px rows —
 * `Collapse all folders` · `Sort by alphabetical order`. That is the whole menu; there is no
 * divider and no third entry.
 *
 * The sort is a per-user preference (`shell.contentSort`), like everything else the shell
 * remembers, so it survives a reload and a different browser.
 */
import { Menu, type MenuEntry } from '../board-view/table/menus/Menu';

export const CONTENT_MENU_WIDTH = 240;

export function ContentSectionMenu({
  x,
  y,
  sortAlphabetically,
  onCollapseAll,
  onToggleSort,
  onClose,
}: {
  x: number;
  y: number;
  sortAlphabetically: boolean;
  onCollapseAll(): void;
  onToggleSort(): void;
  onClose(): void;
}) {
  const entries: MenuEntry[] = [
    {
      id: 'collapse-all',
      label: 'Collapse all folders',
      onSelect: onCollapseAll,
      'data-testid': 'content-collapse-all',
    },
    {
      id: 'sort',
      label: 'Sort by alphabetical order',
      // A toggle, so the current state is visible: monday ticks the active one.
      ...(sortAlphabetically ? { hint: '✓' } : {}),
      onSelect: onToggleSort,
      'data-testid': 'content-sort-alpha',
    },
  ];

  return (
    <Menu entries={entries} x={x} y={y} width={CONTENT_MENU_WIDTH} label="Content options" onClose={onClose} />
  );
}
